import { Component, Input, OnInit } from '@angular/core';


@Component({
  selector: 'app-attempt-grid-date-local-widget',
  templateUrl: './attempt-grid-date-local-widget.component.html',
  styleUrls: ['./attempt-grid-date-local-widget.component.scss']
})
export class AttemptGridDateLocalWidgetComponent implements OnInit {

  @Input() item_id?; // impliments on changes. // Base set to Job_ID
  @Input() item_data?; // if data.model is sent : Observable<any[]>;

  service_local_timezone: string;
  time_of_service: any;

  constructor() {

// const date_to_convert = this.item_data.time_service_local;

 // sets the timezone passed in the item data to output in the datePipe.
      // if(this.item_data.service_local_timezone != ''){
      //   const timezone = this.item_data.service_local_timezone
      //   this.service_local_timezone = timezone;
      // }

   }

  ngOnInit(): void {

console.log('Utem: ' + this.item_data.time_service_local);

  }

}
